module.exports = __webpack_public_path__ + "static/proboard1-d78b532c135077ecc13e95b1c5cec7db.png";